import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as hotkey from '../../hotkey/hotkey.js'
import { close, display, opener, parse } from '../seamless.js'
import * as utilities from '../../styles.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'

const modals = new WeakMap()
const templates = new WeakMap()

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: async (label) => {
    if (modals.has(label)) {
      const modal = modals.get(label)

      remove(modal)
      modals.delete(label)

      return
    }

    const { ownerDocument } = label
    const container = one(`.${utilities.elements.aside_lightboxes}`, ownerDocument)
    const modal = await parse(templates.get(label), container, label)
    const form = one('form[target="_self"]', modal)
    const { dataset } = form
    const { contract = null } = dataset

    hotkey.disable(modal)
    modals.set(label, modal)

    if (contract === null) {
      onSubmit.listen(form)
    }

    await display(modal, label)

    queueMicrotask(async () => {
      await removed(modal)
      modals.delete(label)
    })
  }
})

const onSubmit = object(listener, {
  type: submit,
  passive,
  task: subForm => {
    const modal = closest('[data-contract^="modal."]', subForm)
    const label = opener(modal)
    const { childNodes } = label
    const template = one('template', label)
    const { elements } = subForm
    const contents = []

    for (const childNode of childNodes) {
      contents.push(childNode)

      if (childNode === template) {
        break
      }
    }

    for (const element of elements) {
      const { name, value = null } = element

      if (name && value !== null) {
        contents.push(element.cloneNode(true))
      }
    }

    replaceChildren(label, ...contents)
    close()
  }
})

export default template => {
  const { parentNode } = template

  templates.set(parentNode, template)
  onClick.listen(parentNode)
}